<template>
  <router-view/>
</template>

<style src="@/styles/index.scss"  lang="scss"/>
